import { Grid } from '@material-ui/core'
import React from 'react'
import './styles/WarningQA.css';

export const WarningQA = () => {
    return (
        <div className='warning'>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <p>
                    Ambiente test
                </p>
            </Grid>
        </div>
    )
}